import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "section-text" }, "Información accionistas jurídicos", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "pep-text" }, " Si algún accionista es Persona Jurídica o empresa, se debe identificar los beneficiarios finales o personas naturales con mayor participación (El beneficiario final corresponde a la persona natural que ejerce control sobre la persona Jurídica o estructura sin personería), a continuación indique los beneficiarios finales. ", -1)
const _hoisted_3 = { class: "highlightedTextLegal" }
const _hoisted_4 = { class: "highlightedTextLegal" }
const _hoisted_5 = { class: "pep" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"62px"} }, null, -1)
const _hoisted_7 = { style: {"height":"62px"} }
const _hoisted_8 = { style: {"height":"62px"} }
const _hoisted_9 = { style: {"height":"62px"} }
const _hoisted_10 = { style: {"height":"62px"} }
const _hoisted_11 = { style: {"height":"62px"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"62px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_3, [
                _createElementVNode("b", null, [
                  _createTextVNode("En caso de que las filas no sean suficientes, agrega más filas en \" "),
                  _createVNode(_component_el_button, {
                    circle: "",
                    class: "dinamic-form-button",
                    size: "mini",
                    type: "success ",
                    icon: "el-icon-plus"
                  }),
                  _createTextVNode(" \" ")
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("b", null, [
                  _createTextVNode("En caso de requerir eliminar alguna fila, da clic en \" "),
                  _createVNode(_component_el_button, {
                    circle: "",
                    class: "dinamic-form-button",
                    size: "mini",
                    type: "success ",
                    icon: "el-icon-minus"
                  }),
                  _createTextVNode(" \" ")
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_row, { gutter: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 22 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  height: "300",
                  data: _ctx.objetoInfoAccionista_Juridico.Aj,
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, { width: "40%" }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("span", null, [
                          _createElementVNode("b", null, _toDisplayString(scope.$index + 1), 1)
                        ]),
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      class: "section-text-color",
                      label: "Nombre o razón social de accionista*",
                      width: "260px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          modelValue: scope.row.NombreAJ,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.NombreAJ) = $event),
                          class: _normalizeClass([_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].NombreAJ.length ? 'border-invalid' : 'border-valid'])
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                        _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
                          [_vShow, !_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].NombreAJ.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].NombreAJ, (error) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            key: error,
                            class: "section-error-message"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(error.$message), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Tipo ID*",
                      width: "140px"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_select, {
                          modelValue: scope.row.TipoIdAJ,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.TipoIdAJ) = $event),
                          placeholder: "Seleccionar",
                          class: _normalizeClass([_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].TipoIdAJ.length ? 'border-invalid' : 'border-valid'])
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.tipoDeIdentificacion, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.codigo,
                                label: item.valor,
                                value: item.valor
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "class"]),
                        _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
                          [_vShow, !_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].TipoIdAJ.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].TipoIdAJ, (error) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            key: error,
                            class: "section-error-message"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(error.$message), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "N° ID*",
                      width: "160px"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          modelValue: scope.row.NumeroIdentificacionAJ,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.NumeroIdentificacionAJ) = $event),
                          class: _normalizeClass([_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].NumeroIdentificacionAJ.length ? 'border-invalid' : 'border-valid'])
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                        _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
                          [_vShow, !_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].NumeroIdentificacionAJ.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].NumeroIdentificacionAJ, (error) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            key: error,
                            class: "section-error-message"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(error.$message), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "% Participación Capital o Voto*",
                      width: "200px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          modelValue: scope.row.ParticipacionCapitalAJ,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.ParticipacionCapitalAJ) = $event),
                          class: _normalizeClass([_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].ParticipacionCapitalAJ.length ? 'border-invalid' : 'border-valid']),
                          onChange: ($event: any) => (_ctx.CharPercentage($event,scope.$index)),
                          onKeypress: _ctx.func.OnlyNumbers,
                          maxlength: "4"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "onChange", "onKeypress"]),
                        _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
                          [_vShow, !_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].ParticipacionCapitalAJ.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].ParticipacionCapitalAJ, (error) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            key: error,
                            class: "section-error-message"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(error.$message), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "País de constitución*",
                      width: "180px;"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_select, {
                          modelValue: scope.row.PaisAJ,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.PaisAJ) = $event),
                          placeholder: "Seleccionar",
                          filterable: "",
                          class: _normalizeClass([_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].PaisAJ.length ? 'border-invalid' : 'border-valid'])
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.pais, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.paisid,
                                label: item.nombre,
                                value: item.nombre
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "class"]),
                        _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [
                          [_vShow, !_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].PaisAJ.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionInfoAccionista_Juridico.Aj.$each.$response.$errors[scope.$index].PaisAJ, (error) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            key: error,
                            class: "section-error-message"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(error.$message), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { width: "50" }, {
                      default: _withCtx((scope) => [
                        (scope.$index > 0)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              circle: "",
                              class: "dinamic-form-button",
                              size: "small",
                              type: "success",
                              icon: "el-icon-minus",
                              onClick: ($event: any) => (_ctx.EliminarFilaAJ(scope.$index))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  circle: "",
                  class: "dinamic-form-button",
                  size: "small",
                  type: "success",
                  icon: "el-icon-plus",
                  onClick: _ctx.AgregarFilaAJ
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}